"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Recommendations", {
  enumerable: true,
  get: function () {
    return _Recommendations.Recommendations;
  }
});
Object.defineProperty(exports, "RecommendationsData", {
  enumerable: true,
  get: function () {
    return _Recommendations.RecommendationsData;
  }
});
var _Recommendations = require("./Recommendations");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUmVjb21tZW5kYXRpb25zIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1JlY29tbWVuZGF0aW9ucy9pbmRleC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgUmVjb21tZW5kYXRpb25zLCBSZWNvbW1lbmRhdGlvbnNEYXRhIH0gZnJvbSBcIi4vUmVjb21tZW5kYXRpb25zXCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxnQkFBQSxHQUFBQyxPQUFBIiwiaWdub3JlTGlzdCI6W119